const ProjectList = ({ item, onViewDetails }) => {
  return (
    <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-lg hover:shadow-xl transition duration-300 flex flex-col h-full">
      <div className="mb-4 overflow-hidden rounded-md relative">
        <img
          src={item.image[0]}
          alt={`${item.title} preview`}
          className="w-full h-48 object-cover transition duration-500 hover:scale-105"
        />

        {item.url && (
          <a
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute bottom-2 right-2 px-3 py-1 text-xs font-semibold text-white bg-black bg-opacity-70 rounded-md transition duration-300 hover:bg-opacity-90 z-10"
          >
            View
          </a>
        )}
      </div>

      <h3 className="text-xl font-bold text-gray-900 mb-2 truncate">
        {item.title}
      </h3>

      <p className="text-gray-600 mb-4 flex-grow line-clamp-3">
        {item.description}
      </p>

      <div className="flex flex-wrap gap-2 mb-4">
        {item.category &&
          item.category.slice(0, 3).map((tag, index) => (
            <span
              key={index}
              className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded-full"
            >
              {tag}
            </span>
          ))}
      </div>

      <button
        onClick={onViewDetails}
        className="mt-auto w-full bg-crimson text-white font-semibold px-4 py-2 rounded-lg transition duration-300 ease-in-out hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-crimson focus:ring-opacity-50"
      >
        View Details
      </button>
    </div>
  );
};

export default ProjectList;
